import React from "react";
import { Fragment } from "react";
import { Link } from "react-router-dom";

export default function ShoppingHeader() {
  return (
    <Fragment>
      <div className="row customers shopHeader aboveHEade">
        <div>
          <h2>Add Shopping List</h2>
        </div>
      </div>
    </Fragment>
  );
}
